module.exports = __webpack_public_path__ + "static/img/zenith.c2a2273b.png";